import { ENTITY_LISTING_VIEW_TYPE } from '../../../constants/common'

// TODO: keep the view regime and preview width in a backend config once the
// page has one.
const MOCK_INTEGRATIONS_CONFIG = {
  preview: { size: null },
  view: ENTITY_LISTING_VIEW_TYPE.table,
}

export function getMockIntegrationsConfig() {
  return { ...MOCK_INTEGRATIONS_CONFIG }
}

export function patchMockIntegrationsConfig(config) {
  Object.assign(MOCK_INTEGRATIONS_CONFIG, config)
}
